// Dependencies
import React from 'react';
import moment from 'moment';

// Components
import * as ReportUtils from 'utils/report';
import { REPORTS_URL } from 'constants/Jaws';

if (process.env.NODE_ENV !== 'test') {
  require('./Reports.scss');
}

const dateFormat = 'DD-MM-YYYY';

export default class Reports extends React.Component {
  state = {
    meta: {},
  };

  componentWillMount() {
    this.fetchMetadata();
  }

  fetchMetadata() {
    const { meta } = this.state;

    ReportUtils.fetchMetadata('MORNING_REPORT').end((err, res) => {
      if (err) return null;
      meta.morning = res.body;
      this.setState({ meta });
    });

    ReportUtils.fetchMetadata('STRATEGY_REPORT').end((err, res) => {
      if (err) return null;
      meta.strategy = res.body;
      this.setState({ meta });
    });
  }

  render() {
    const { meta } = this.state;

    return (
      <span className="Reports">
        {meta.morning && (
          <div className="link-wrapper">
            <a href={`${REPORTS_URL}?type=MORNING_REPORT`}>
              <span className="hidden-xs">
                <i className="fa fa-cloud-download" />
              </span>
              <div className="dl">
                Strategirapport
                <div>
                  {moment(meta.morning.lastModified).format(dateFormat)}
                  <span className="visible-xs">
                    <i className="fa fa-cloud-download" />
                  </span>
                </div>
              </div>
            </a>
          </div>
        )}
        {meta.strategy && (
          <div className="link-wrapper">
            <a href={`${REPORTS_URL}?type=STRATEGY_REPORT`}>
              <span className="hidden-xs">
                <i className="fa fa-cloud-download" />
              </span>
              <div className="dl">
                Makrorapport
                <div>
                  {moment(meta.strategy.lastModified).format(dateFormat)}
                  <span className="visible-xs">
                    <i className="fa fa-cloud-download" />
                  </span>
                </div>
              </div>
            </a>
          </div>
        )}
      </span>
    );
  }
}
